export default __webpack_public_path__ + "static/media/kid-1.96059494.jpg";